import(/* webpackMode: "eager", webpackExports: ["default","iconNames"] */ "/vercel/path0/node_modules/lucide-react/dist/esm/DynamicIcon.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(frontend)/[lang]/hotels/[country]/CountryClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/common/ReadmoreDesc.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/layout/PageBreadcrumbs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ImageMedia"] */ "/vercel/path0/src/components/Media/ImageMedia/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VideoMedia"] */ "/vercel/path0/src/components/Media/VideoMedia/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AspectRatio"] */ "/vercel/path0/src/components/ui/aspect-ratio.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/public/illustrations/member.svg");
